module.exports = __webpack_public_path__ + "static/agenda-svg-5053f377750cb0befd3ac57f853406aa.svg";